export default {
    users: [],
    guests: [],
    user: [],
};
